module.exports = __webpack_public_path__ + "AdobeStock_161673435_shaded6.1.png?9bc9ebd41c1f5984f7b676ada1f8114b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/AdobeStock_161673435_shaded6.1.png
// module id = 319
// module chunks = 0